import { getToken, setToken, removeToken } from "@/utils/auth";
export default{

    helpOrderMemberLogin(that,postObj){
        that.$store.dispatch("member/login", postObj).then(res=>{
            if(res.code >= 0){
                let href = window.location.href;
                href = href.split("?")[0];
                window.location.href = href;
                that.$loading(false);
            }
        })
    },
    helpOrderInit(that){
        let query = that.$route.query;
        if(query){
            let {type,username} = query;
            if(type && type=="help_order" && username){
                // element ui 弹出确认警告
                
                that.$confirm("检测到帮下单跳转，是否登录？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then((val) => {
                    if(val){
                        // element ui 页面loading
                        that.$loading({
                            lock: true,
                            text: "登录中...",
                            background: "rgba(0, 0, 0, 0.7)"
                        });
                        let token = getToken();
                        let postObj = {
                            username,
                            password: "jxkj123"
                        };
                        if(token){
                            removeToken();
                            sessionStorage.clear();
                            setTimeout(()=>{
                                this.helpOrderMemberLogin(that,postObj);
                            },200);
                        }else{
                            this.helpOrderMemberLogin(that,postObj);
                        }
                    }
                }).catch(() => {
                    
                });
            }
        }
    }
}